import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { 
  FaThLarge, FaSearch, FaHistory, 
  FaHandsHelping, FaUser 
} from 'react-icons/fa';
import './MobileBottomNav.css';

const MobileBottomNav = () => {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const currentLang = i18n.language || 'hi';

  const isHindi = currentLang === 'hi';

  return (
    <nav className="fd-mobile-bottom-nav">
      <NavLink 
        to="/dashboard" 
        className={({ isActive }) => `fd-mob-nav-item ${isActive ? 'active' : ''}`}
      >
        <FaThLarge className="fd-mob-nav-icon" />
        <span className="fd-mob-nav-text">{isHindi ? 'डैशबोर्ड' : 'Dashboard'}</span>
      </NavLink>

      <NavLink 
        to="/check-risk" 
        className={({ isActive }) => `fd-mob-nav-item ${isActive ? 'active' : ''}`}
      >
        <FaSearch className="fd-mob-nav-icon" />
        <span className="fd-mob-nav-text">{isHindi ? 'चेक रिस्क' : 'Check Risk'}</span>
      </NavLink>

      <NavLink 
        to="/history" 
        className={({ isActive }) => `fd-mob-nav-item ${isActive ? 'active' : ''}`}
      >
        <FaHistory className="fd-mob-nav-icon" />
        <span className="fd-mob-nav-text">{isHindi ? 'इतिहास' : 'History'}</span>
      </NavLink>

      <NavLink 
        to="/interventions" 
        className={({ isActive }) => `fd-mob-nav-item ${isActive ? 'active' : ''}`}
      >
        <FaHandsHelping className="fd-mob-nav-icon" />
        <span className="fd-mob-nav-text">{isHindi ? 'सपोर्ट' : 'Support'}</span>
      </NavLink>

      <NavLink 
        to="/profile" 
        className={({ isActive }) => `fd-mob-nav-item ${isActive ? 'active' : ''}`}
      >
        <FaUser className="fd-mob-nav-icon" />
        <span className="fd-mob-nav-text">{isHindi ? 'प्रोफ़ाइल' : 'Profile'}</span>
      </NavLink>
    </nav>
  );
};

export default MobileBottomNav;
